import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {buildQuery} from "utils/uri";

export default function fetchTopicParametersByTopicId(requestor) {
  return createReduxPromiseAction(
    ActionTypes.TOPIC_PARAMETERS_BY_TOPIC_ID_FETCH,
    (organisationId, topicId, params) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}/topic/${topicId}/topicparameters${buildQuery(
            params,
          )}`,
          {
            withCredentials: true,
          },
        )
        .then(response => response.data),
  );
}
